import React,{useEffect,useState,useContext} from 'react'
import axios from 'axios'
import { AuthContextUser } from "../context/UserContext";
import { ToastContainer, toast } from "react-toastify";

export const Memoir = () => {

    const { currentUser } = useContext(AuthContextUser);

if (currentUser.tel === null) {
    } else {

return (
    <>
 <section class="m-0 content" dir='rtl'>
            <div class="d-flex flex-column justify-content-start align-items-center">
                <div class="card">
                    <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
                    <div class="d-flex flex-column justify-content-start card-title-container">
                        <div class="card-title text-secondary">شرح حال</div>
                        <p class="card-subtitle">نمایش شرح حال</p>
                    </div>

                    <div class="d-flex flex-column flex-md-row justify-content-between w-100 t-8">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="شماره پرونده" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام و نام خانوادگی" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام پدر" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="تاریخ تولد" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام بخش" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="شماره اتاق" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="تخت" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="پزشک معالج" />
                        </div>
                    </div>
                    <div class="seprator my-24"></div>
                    <div class="form-group position-relative w-100">
                        <div class="card-title text-secondary b-16">نشانه های فعلی بیمار</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="نشانه های فعلی بیمار">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">تاریخچه بیماری های قبلی</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="تاریخچه بیماری های قبلی">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">داروهای درحال مصرف و اعتیادات</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="داروهای درحال مصرف و اعتیادات">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">درصورت داشتن حساسیت به چیزی آن را بنویسید</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="درصورت داشتن حساسیت به چیزی آن را بنویسید">

                        </textarea>
                    </div>
                    <div class="d-flex flex-xl-row flex-column w-100 justify-content-center align-items-center t-24">
                        <p class="m-0 w-auto">پوست:</p>
                        <input type="text" class="form-control pr-16 my-2 ms-md-3"
                            placeholder="درصورت مشاهده حساسیت بنویسید" />
                    </div>
                    <div class="d-flex flex-xl-row flex-column w-100 justify-content-center align-items-center t-24">
                        <p class="m-0 w-auto">جمجمه:</p>
                        <input type="text" class="form-control pr-16 my-2 ms-md-3"
                            placeholder="درصورت مشاهده حساسیت بنویسید" />
                    </div>
                    <div class="d-flex flex-xl-row flex-column w-100 justify-content-center align-items-center t-24">
                        <p class="m-0 w-auto">گوش:</p>
                        <input type="text" class="form-control pr-16 my-2 ms-md-3"
                            placeholder="درصورت مشاهده حساسیت بنویسید" />
                    </div>
                </div>
            </div>
        </section>
    </>
  )
    }
}
